"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingHistoryList = exports.isDualFuel = exports.getMigrationTransactions = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var core_1 = require("../../../../../../shared/core");
var analytics_subjects_1 = require("../../../../analytics-subjects");
var constants_1 = require("../../../../constants");
var copy_1 = require("../../../../copy");
var date_1 = require("../../../../utils/date");
var estimates_1 = require("../../../../utils/estimates");
var ExpandableBillingPeriod_1 = require("./ExpandableBillingPeriod");
var LegacyBillingPeriodItem_1 = require("./LegacyBillingPeriodItem");
var MigrationCard_1 = require("./MigrationCard");
var BillingPeriodContent_1 = require("./expandable-content/BillingPeriodContent");
var getMigrationTransactions = function (periods) {
    return periods.reduce(function (acc, period) {
        var periodBalances = period.transactions.filter(function (transaction) { return transaction.description === 'Migrated Balance'; });
        return __spreadArray(__spreadArray([], __read(acc), false), __read(periodBalances), false);
    }, []);
};
exports.getMigrationTransactions = getMigrationTransactions;
var MIGRATION_NOTICE_ANALYTICS_ERROR_EVENT = 'MigrationNoticeBillingError';
var isDualFuel = function (periods) {
    return periods.some(function (element) {
        return element.gas !== null &&
            (element.electricity !== null || element.electricityCharges !== null);
    });
};
exports.isDualFuel = isDualFuel;
var BillingHistoryList = function (_a) {
    var _b, _c, _d;
    var _e = _a.billingHistory, orionBillingHistory = _e.orionBillingHistory, legacyBillingHistory = _e.legacyBillingHistory, migrationNotices = _e.migrationNotices;
    var features = (0, core_1.useFeatureContext)().features;
    var legacyHistoryItemCount = legacyBillingHistory.length;
    var orionHistoryItemCount = orionBillingHistory.length;
    var totalHistoryItemCount = legacyHistoryItemCount + orionHistoryItemCount;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var _f = (0, core_1.useComponents)(), SecondaryCTAButton = _f.SecondaryCTAButton, Stack = _f.Stack;
    var periodsToShow = constants_1.INITIAL_PERIODS_TO_SHOW;
    var _g = __read((0, react_1.useState)(Math.min(periodsToShow, totalHistoryItemCount)), 2), currentItem = _g[0], setCurrentItem = _g[1];
    var dispatch = (0, ui_tools_1.useAnalytics)().dispatch;
    var _h = __read((0, react_1.useState)(window.scrollY), 2), pageCurrentVerticalPosition = _h[0], setPageCurrentVerticalPosition = _h[1];
    (0, react_1.useEffect)(function () {
        window.scrollTo(0, pageCurrentVerticalPosition);
    }, [pageCurrentVerticalPosition]);
    var orionSlice = currentItem < orionHistoryItemCount ? currentItem : orionHistoryItemCount;
    var orionSliceOverflow = currentItem - orionSlice;
    var legacySlice = orionSliceOverflow >= 0
        ? orionSliceOverflow < legacyHistoryItemCount
            ? orionSliceOverflow
            : legacyHistoryItemCount
        : 0;
    var orionHistoryToShow = orionBillingHistory.slice(0, orionSlice);
    var forwardedReadDates = (0, estimates_1.getForwardedReadDates)(orionHistoryToShow);
    var legacyHistoryToShow = legacyBillingHistory.slice(0, legacySlice);
    var moreToLoad = currentItem < totalHistoryItemCount;
    var handleLoadMore = function () {
        var _a;
        var amountToLoad = Math.min(currentItem + constants_1.AMOUNT_TO_LOAD, totalHistoryItemCount);
        dispatch({
            name: analytics_subjects_1.BILLING_LOAD_MORE,
            type: 'click',
            properties: (_a = {},
                _a[core_1.INTERNAL_EVENT_FLAG] = true,
                _a),
        });
        setPageCurrentVerticalPosition(window.scrollY);
        setCurrentItem(amountToLoad);
    };
    var migrationTransactions = (0, exports.getMigrationTransactions)(migrationNotices);
    var hasValidMigrationDates = migrationTransactions.length &&
        (0, exports.getMigrationTransactions)(migrationNotices).reduce(function (acc, transaction) {
            return (acc &&
                !!transaction.date &&
                new Date(transaction.date).toString() !== 'Invalid Date');
        }, true);
    return (react_1.default.createElement(Stack, { spaceBetween: [4, 8] },
        react_1.default.createElement(react_1.default.Fragment, null, orionHistoryToShow.map(function (period, index) {
            var start = period.start, end = period.end, electricity = period.electricity, gas = period.gas, periodId = period.periodId, totalCharge = period.totalCharge;
            var _a = (0, date_1.formatHeadingDateRange)(start, end), startDate = _a.startDate, endDate = _a.endDate;
            var title = "".concat(startDate, " \u2013 ").concat(endDate);
            var total = (0, core_1.major2DP)((0, core_1.majorToMinor)(totalCharge.grossCharge.pounds));
            return (react_1.default.createElement(ExpandableBillingPeriod_1.ExpandableBillingPeriod, { title: title, total: total, subtitle: electricity && gas
                    ? 'Bill for electricity and gas'
                    : electricity
                        ? 'Bill for electricity'
                        : gas
                            ? 'Bill for gas'
                            : '', id: periodId.toString(), key: periodId, 
                // Expand the first period by default.
                expanded: index === 0 && !!(features && features.expandFirstBillingPeriod) },
                react_1.default.createElement(BillingPeriodContent_1.BillingPeriodContent, { period: period, latestReadDates: forwardedReadDates[index] })));
        })),
        !moreToLoad &&
            (hasValidMigrationDates ? (react_1.default.createElement(ui_tools_1.AnalyticsRender, { name: analytics_subjects_1.MIGRATION_NOTICE_ANALYTICS_EVENT, properties: (_b = {
                        numberOfMigratedBalanceTransaction: migrationTransactions.length,
                        migratedBalances: migrationTransactions.map(function (_a) {
                            var netCredit = _a.netCredit;
                            return netCredit;
                        })
                    },
                    _b[core_1.INTERNAL_EVENT_FLAG] = true,
                    _b) }, migrationTransactions.length ? (react_1.default.createElement(MigrationCard_1.MigrationCard, { key: "migrationCard", transactions: migrationTransactions, isDualFuel: (0, exports.isDualFuel)(orionBillingHistory), hasLegacyStatements: legacyHistoryItemCount > 0 })) : null)) : (react_1.default.createElement(ui_tools_1.AnalyticsRender, { name: MIGRATION_NOTICE_ANALYTICS_ERROR_EVENT, properties: (_c = {
                        reason: 'invalid migration date'
                    },
                    _c[core_1.INTERNAL_EVENT_FLAG] = true,
                    _c) }, null))),
        !moreToLoad &&
            legacyHistoryToShow.map(function (period) { return (react_1.default.createElement(LegacyBillingPeriodItem_1.LegacyBillingPeriodItem, { key: period.statementId, period: period })); }),
        moreToLoad && (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.BILLING_LOAD_MORE, properties: (_d = {}, _d[core_1.INTERNAL_EVENT_FLAG] = true, _d) },
            react_1.default.createElement(SecondaryCTAButton, { "data-testid": constants_1.LOAD_MORE_TEST_ID, onClick: handleLoadMore },
                react_1.default.createElement(Copy, { copyKey: "loadMore" }))))));
};
exports.BillingHistoryList = BillingHistoryList;
